// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"JobCardButtonGroup_buttonContainer__2OTEY","date":"JobCardButtonGroup_date__1EcDi","sending":"JobCardButtonGroup_sending__5YXXF"};